export default "__VITE_PUBLIC_ASSET__1fc864f2__"